<template>
  <PageBreadcrumb
    :crumbs="[{
      link: '/aste/',
      label: 'Gestione Aste'
    }, router.options.history.state.back.indexOf('visualizza') === -1 ? {
      link: '/aste/' + auctionId + '/lotti',
      label: 'Gestione Lotti Asta' + auction.name
    } : {
      link: '/aste/' + auctionId + '/visualizza-lotti',
      label: 'Visualizza Lotti Asta' + auction.name
    }, {
      label: 'Lotto ' + lot.code
    }]"
  />
    
  <form autocomplete="off">
    <InputText
      v-model="lot.code"
      :disabled="true"
      :error-fields="errorFields"
      name="code"
      :submitted="submitted"
    >
      Codice
    </InputText>

    <InputInteger
      v-model="lot.quantity"
      :disabled="true"
      :error-fields="errorFields"
      name="quantity"
      :submitted="submitted"
    >
      Quantità<br><span class="text-sm">(in tonnellate)</span>
    </InputInteger>

    <ProductInputSelect
      v-model="lot.productUuid"
      :category-uuid="auction.categoryUuid"
      :disabled="true"
      :error-fields="errorFields"
      name="productUuid"
      :submitted="submitted"
    />

    <WasteCodeInputSelect
      v-model="lot.wasteCodeUuid"
      :disabled="true"
      :error-fields="errorFields"
      name="wasteCodeUuid"
      :submitted="submitted"
    />

    <InputInteger
      v-model="lot.preemptedQuantity"
      :disabled="true"
      :error-fields="errorFields"
      name="preemptedQuantity"
      :submitted="submitted"
    >
      Quantità redistribuita<br><span class="text-sm">(in tonnellate)</span>
    </InputInteger>

    <InputInteger
      v-model="lot.assignedQuantity"
      :disabled="true"
      :error-fields="errorFields"
      name="assignedQuantity"
      :submitted="submitted"
    >
      Quantità assegnata<br><span class="text-sm">(in tonnellate)</span>
    </InputInteger>

    <InputDecimal
      v-model="lot.startPrice"
      :disabled="true"
      :error-fields="errorFields"
      name="startPrice"
      :submitted="submitted"
    >
      Prezzo Iniziale<br><span class="text-sm">(in euro €)</span>
    </InputDecimal>

    <InputDecimal
      v-model="lot.bidPrice"
      :disabled="true"
      :error-fields="errorFields"
      name="bidPrice"
      :submitted="submitted"
    >
      Rilancio<br><span class="text-sm">(in euro €)</span>
    </InputDecimal>

    <h4 class="uppercase text-sm mb-4 mt-8 font-bold">
      Informazioni addizionali
    </h4>

    <InputSelect
      v-model="lot.attributes.tipoPagamento"
      :disabled="true"
      :error-fields="errorFields"
      name="tipoPagamento"
      :options="tipoPagamentoValues"
      :submitted="submitted"
    >
      Condizioni di Pagamento
    </InputSelect>

    <InputSelect
      v-model="lot.attributes.territorioInteresse"
      :disabled="true"
      :error-fields="errorFields"
      name="territorioInteresse"
      :options="territorioInteresseValues"
      :submitted="submitted"
    >
      Territorio di Interesse
    </InputSelect>

    <InputSelect
      v-model="lot.attributes.provenienzaProdotto"
      :disabled="true"
      :error-fields="errorFields"
      name="provenienzaProdotto"
      :options="provenienzaProdottoValues"
      :submitted="submitted"
    >
      Provenienza del Prodotto
    </InputSelect>

    <InputText
      v-model="lot.attributes.dataDisponibilitaMateriale"
      :disabled="true"
      :error-fields="errorFields"
      name="dataDisponibilitaMateriale"
      :submitted="submitted"
    >
      Data Disponibilità Materiale
    </InputText>

    <InputSelect
      v-model="lot.attributes.tipologiaProdotto"
      :disabled="true"
      :error-fields="errorFields"
      name="tipologiaProdotto"
      :options="tipologiaProdottoValues"
      :submitted="submitted"
    >
      Tipologia di Prodotto
    </InputSelect>

    <InputSelect
      v-model="lot.attributes.statoFisico"
      :disabled="true"
      :error-fields="errorFields"
      name="statoFisico"
      :options="statoFisicoValues"
      :submitted="submitted"
    >
      Stato del Prodotto
    </InputSelect>

    <InputSelect
      v-model="lot.attributes.imballaggio"
      :disabled="true"
      :error-fields="errorFields"
      name="imballaggio"
      :options="imballaggioValues"
      :submitted="submitted"
    >
      Imballaggio
    </InputSelect>

    <InputSelect
      v-model="lot.attributes.qualitaMateriale"
      :disabled="true"
      :error-fields="errorFields"
      name="qualitaMateriale"
      :options="qualitaMaterialeValues"
      :submitted="submitted"
    >
      Qualità Materiale
    </InputSelect>

    <InputTextarea
      v-model="lot.notes"
      :disabled="true"
      :error-fields="errorFields"
      name="notes"
      :submitted="submitted"
    >
      Note
    </InputTextarea>

    <div class="flex mb-4 mt-8">
      <h4 class="uppercase text-sm flex-grow font-bold">
        Depositi
      </h4>
    </div>

    <div
      v-for="warehouse, index in lot.warehouses"
      :key="'lot-warehouses-' + index"
      class="flex mb-2 text-sm border-b items-start"
    >
      <div class="flex flex-grow mr-2">
        <div class="w-1/2 mr-2">
          <InputSelect
            v-model="warehouse.selectionSiteUuid"
            :disabled="true"
            :error-fields="errorFields"
            :name="'warehouses.' + index + '.selectionSiteUuid'"
            :options="selectionSites"
            :submitted="submitted"
          >
            Centro di Selezione
          </InputSelect>
        </div>
        <div class="w-1/2 ml-2">
          <InputInteger
            v-model="warehouse.quantity"
            :disabled="true"
            :error-fields="errorFields"
            :name="'warehouses.' + index + '.quantity'"
            :submitted="submitted"
          >
            Quantità
            <br><span class="text-xs">(in tonnellate)</span>
          </InputInteger>
        </div>
      </div>
    </div>
  </form>
</template>
  
<script setup>
import {
  MinusCircleIcon,
  PlusCircleIcon} from "@heroicons/vue/24/outline";
import _ from "underscore";
import { reactive, ref, watch } from "vue";
import { useRoute, useRouter } from 'vue-router';

import ActionButton from "@/components/ActionButton.vue";
import ErrorRow from "@/components/form/ErrorRow.vue";
import InputDecimal from "@/components/form/InputDecimal.vue";
import InputInteger from "@/components/form/InputInteger.vue";
import InputSelect from "@/components/form/InputSelect.vue";
import InputText from "@/components/form/InputText.vue";
import InputTextarea from "@/components/form/InputTextarea.vue";
import ProductInputSelect from "@/components/form/ProductInputSelect.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import WasteCodeInputSelect from "@/components/form/WasteCodeInputSelect.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";
import useLotAttributes from '@/composables/lotAttributes.js'
import { useNotificationsStore } from "@/stores/notifications";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const { 
  imballaggioValues, 
  provenienzaProdottoValues, 
  qualitaMaterialeValues,
  statoFisicoValues,
  territorioInteresseValues,
  tipologiaProdottoValues,
  tipoPagamentoValues
} = useLotAttributes();

const axios = useAxios();
const route = useRoute();
const router = useRouter();

const auctionId = route.params.auctionId
const auctionResp = await axios.get('/auction/' + auctionId);
const auction = ref(auctionResp.data);

const selectionSiteResp = await axios.get('/selection-site/list')
const selectionSites = selectionSiteResp.data.map((selectionSite) => {
  return {
    id: selectionSite.uuid,
    label: selectionSite.displayName
  }
})

const lot = ref(null);
const errorFields = ref({})
const submitted = ref(false);

const resp = await axios.get("/lot/" + props.id);
if(!resp.data.attributes) {
  resp.data.attributes = {};
}
lot.value = resp.data;

</script>
